import * as React from "react";
import { Component } from "react";
import Moment from "react-moment";
import { EvalWorkflow } from "../../api/EvalWorkflowApi";
import { AdminEvalPass } from "../../api/EvalStudyAdminApi";
import i18n from "i18next";
import { EvalObservation } from "../../component/observation/GroundTruthComponents";

interface AdminEvalPassDetailProps {
  pass: AdminEvalPass;
  passIdx: number;
}

export default class AdminEvalPassDetail extends Component<AdminEvalPassDetailProps> {
  constructor(props: AdminEvalPassDetailProps) {
    super(props);
  }

  render() {
    return (
      <div key={this.props.pass.at + "-" + this.props.pass.author + "-" + this.props.pass.workflow} className="card">
        <div className="card-title" style={{ color: this.props.pass._passColor }}>
          {i18n.t("global.pass")} {this.props.passIdx} : {this.props.pass.workflow}
        </div>
        <div className="card-body">
          <div>
            {i18n.t("admin.at")} : <Moment format="DD/MM/YYYY HH:mm">{this.props.pass.at}</Moment>
          </div>
          <div>
            {i18n.t("admin.author")} : {this.props.pass.author}
          </div>
          {this.displayTags()}
          {this.props.pass.observations.map((obs, obsIdx) => (
            <EvalObservation key={obsIdx} obs={obs} />
          ))}
          {(this.props.pass.workflow === EvalWorkflow.RD || this.props.pass.workflow === EvalWorkflow.RD_AI) &&
            this.displayReaderPass()}
          {this.props.pass.workflow === EvalWorkflow.RD_AI && (
            <div>
              {i18n.t("admin.secBeforeAI")}: {this.props.pass.secDurationBeforeAiActivation} sec
            </div>
          )}
          {this.props.pass._result && this.displayResult()}
        </div>
      </div>
    );
  }

  private displayTags() {
    const { tags } = this.props.pass;
    if (!tags || tags.length <= 0) {
      return null;
    }

    return (
      <div>
        Tags :{" "}
        {tags.map((tag) => (
          <span className="badge badge-info mr-1" key={tag}>
            {tag}
          </span>
        ))}
      </div>
    );
  }

  private displayResult() {
    return (
      <>
        <div>FalsePositive: {this.props.pass._result.falsePositive}</div>
        <div>FalseNegative: {this.props.pass._result.falseNegative}</div>
        <div>TruePositive: {this.props.pass._result.truePositive}</div>
        <div>TrueNegative: {this.props.pass._result.trueNegative}</div>
        <div>NbMarkerOutsideAnyGTRegion: {this.props.pass._result.nbMarkerOutsideAnyGTRegion}</div>
        <div>Total observations: {this.props.pass._result.totalObs}</div>
        <div>Observations found:</div>
        <ul>
          {this.props.pass._result.foundObsCodes.map((code) => (
            <li key={code}>{code}</li>
          ))}
        </ul>
      </>
    );
  }

  private displayReaderPass() {
    return (
      <div>
        <div>Nb markers : {this.props.pass.markers.length}</div>
        <div>Duration : {this.props.pass.secDuration} sec</div>
      </div>
    );
  }
}
